import React from "react";
import PropTypes from "prop-types";
import EditIcon from "assets/images/form/edit-icon.svg";
import DeleteIcon from "assets/images/form/delete-icon.svg";
import { useRecoilValue } from "recoil";
import { getUserRole } from "recoil/Auth";

function CategoryActions({ data, props }) {
  const userRole = useRecoilValue(getUserRole);
  const editCategory = () => {
    props.setEditObj(data);
  };
  const deleteCategory = async () => {
    props.deleteCategoryConfirmation(data.id);
  };

  return (
    <>
      {userRole === "BUSINESS_ADMIN" && (
        <div className="d-flex gap-3 table-actions">
          <img onClick={editCategory} src={EditIcon} alt="edit-icon" />
          <img onClick={deleteCategory} src={DeleteIcon} alt="edit-icon" />
        </div>
      )}
    </>
  );
}
CategoryActions.propTypes = {
  data: PropTypes.object.isRequired,
  props: PropTypes.object.isRequired,
};
export default CategoryActions;
